import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { ErrorResponse } from '../../models/error.model';
import { MessageResponse } from '../../models/message.model';
import { User } from '../../models/user.model';

export class ApiDigitalAuthPassword {
  static apiResponse: ApiResponse

  public static async postRequest(
    api_key: string,
    email: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let users: User[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/users.data.json').then(response => { users = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (users!.some(item => item.email === email)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/password/request`

      let data: any = {
        email: email
      }

      await axios.post(url, data).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async postReset(
    api_key: string,
    password: string,
    password_confirmation: string,
    password_token: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let users: User[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/users.data.json').then(response => { users = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (users!.some(item => item.password !== password)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/password/reset`

      let data: any = {
        password: password,
        password_confirmation: password_confirmation,
        password_token: password_token
      }

      await axios.post(url, data).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }
}
